<template>
  <div class="performance">
    <div class="performance__inner pretty-scrollbar">
      <header class="performance__header">
        <BaseTitle
          v-if="title"
          v-html="title"
          size="xxl"
          is-up
          class="performance__name"
        />
        <BaseText
          v-if="recommendation"
          v-html="recommendation"
          size="m"
        />
        <div v-if="$slots.actions" class="performance__actions">
          <slot name="actions" />
        </div>
      </header>
      <div class="performance__content">
        <div class="performance__col">
          <BaseText v-html="story" />
          <slot />
        </div>
        <div class="performance__col performance__col_side">
          <BaseText size="s">
            <p v-if="subtitle" v-html="subtitle" />
            <p v-if="author">
              <b>{{ $t('texts.author') }}:</b> {{ author }}
            </p>
          </BaseText>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BaseTitle from '@/components/BaseTitle.vue';
import BaseText from '@/components/BaseText.vue';

export default {
  name: 'Performance',
  components: {
    BaseTitle,
    BaseText,
  },
  props: {
    title: {
      type: String,
      default: '',
    },
    subtitle: {
      type: String,
      default: '',
    },
    description: {
      type: String,
      default: '',
    },
    author: {
      type: String,
      default: '',
    },
    age: {
      type: String,
      default: '',
    },
  },
  computed: {
    recommendation() {
      if (!this.age) return '';
      return this.$t('texts.recommendedAge', { age: this.age });
    },
    story() {
      return this.description || this.$t('texts.noDescription');
    },
  },
};
</script>

<style lang="stylus">
.performance
  display block

  &__inner
    width 100%
    height 100%
    overflow-y scroll
    padding-right 'calc(%s - %s)' % ($side_padding ($scroll_width * 1px))

  &__header
  &__content
    padding $side_padding * 1.4

  &__header
    display block
    background-color $c_bright
    padding-top 4em
    color #fff

  &__name
    margin-bottom 0.1em

  &__actions
    margin-top 2em
    .button
      margin-right 1em

  &__content
    display flex
    padding-bottom 0

  &__col
    flex-grow 1
    flex-basis 0
    max-width 100%
    padding-right 2em
    &_side
      padding-right 0
      max-width 40%
      border-left solid 0.15em currentColor
      padding-top 0.25em
      padding-bottom 0.25em
      padding-left 1.5em
      align-self flex-start
</style>
